import { FlowInformation } from '../../../../@types/flow-types'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../../../app/hooks'
import { InitState } from '../../../../redux/reducers/root/initialState'
import { useCallback } from 'react'
import { tracking } from '../../../../tracking/tracking'
import { IMMOBILIENSCOUT_24_PORTAL_URL } from '../../../../config'

export const useGoBackCallback = (flowInformation: FlowInformation) => {
  const navigate = useNavigate()
  const objectChooserBackButton = useAppSelector(
    (state: InitState) => state.flowFeature.objectChooserInformation.objectChooserBackButton
  )

  const handleNavigation = useCallback(() => {
    const hasHistory = window.history.length > 1
    const listingOverviewUrl = `${IMMOBILIENSCOUT_24_PORTAL_URL}/scoutmanager/angebotsliste/app/overview.html`
    const isComingFromOPA = document.referrer.includes('/scoutmanager/veroeffentlichung/')

    if (isComingFromOPA) {
      window.location.href = listingOverviewUrl
    } else {
      // Standard navigation
      if (hasHistory) {
        navigate(-1)
      } else {
        window.location.href = listingOverviewUrl
      }
    }
  }, [navigate])

  return useCallback(() => {
    if (objectChooserBackButton) {
      tracking({
        eventName: 'object_edit_click',
        flowInformation: flowInformation,
        entryMode: 'create',
        experiment: 'object_chooser',
      })
      handleNavigation()
      return
    }
    handleNavigation()
  }, [objectChooserBackButton, flowInformation, handleNavigation])
}
